import React from 'react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = () => {
    const { toggleTheme, isDark } = useTheme();

    // Light bulb icon (on state)
    const LightBulbIcon = () => (
        <svg 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        >
            <path d="M9 18h6" />
            <path d="M10 22h4" />
            <path d="M12 8a4 4 0 0 0-4 4 7.5 7.5 0 0 0 1 3h6a7.5 7.5 0 0 0 1-3 4 4 0 0 0-4-4Z" />
            <path d="M8 6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
            <path d="M8 2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
        </svg>
    );

    // Light bulb off icon (dark state)
    const LightBulbOffIcon = () => (
        <svg 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        >
            <path d="M16.8 11.2c.8-.9 1.2-2 1.2-3.2a6 6 0 0 0-9.3-5" />
            <path d="M2 2l20 20" />
            <path d="M6.3 6.3a4.67 4.67 0 0 0 1.2 5.2c.7.7 1.3 1.5 1.5 2.5" />
            <path d="M9 18h6" />
            <path d="M10 22h4" />
        </svg>
    );

    return (
        <div className="theme-toggle-container">
            <button
                onClick={toggleTheme}
                className={`theme-toggle-button ${isDark ? 'dark' : 'light'}`}
                title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
                aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
            >
                <div className="icon-container">
                    {isDark ? <LightBulbIcon /> : <LightBulbOffIcon />}
                </div>
                <span className="theme-label">
                    {isDark ? 'Light' : 'Dark'}
                </span>
            </button>
        </div>
    );
};

export default ThemeToggle;
